export const formatDateTime = (value?: string): string => {
  if (!value) return 'N/A';
  const d = new Date(value);
  return isNaN(d.getTime()) ? value : d.toLocaleString();
};
